import { render, staticRenderFns } from "./QCReportsView.vue?vue&type=template&id=542c398a&scoped=true&"
import script from "./QCReportsView.vue?vue&type=script&lang=js&"
export * from "./QCReportsView.vue?vue&type=script&lang=js&"
import style0 from "./QCReportsView.vue?vue&type=style&index=0&id=542c398a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542c398a",
  null
  
)

export default component.exports